import {Component, input} from '@angular/core'

@Component({
  selector: 'spb-read-only',
  imports: [],
  templateUrl: './read-only.component.html',
  styleUrl: './read-only.component.scss'
})
export class ReadOnlyComponent {
  public label = input.required<string>()
  public value = input.required<string>()
}
